import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MatrixRain from './MatrixRain';
import WaveText from './WaveText';
import PrizePreview from './PrizePreview';

const SostieniciSection = () => {
  const [previewBelt, setPreviewBelt] = useState(null);

  return (
  <section data-testid="sostienici-section" className="py-24 border-t border-white/10 relative overflow-hidden">
    <MatrixRain opacity={0.05} speed={0.7} />
    <div className="max-w-5xl mx-auto px-6">
      <div className="text-center mb-12">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">La domanda non è SE, ma</p>
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
          Che cintura sei?
        </h2>
        <p className="text-zinc-400">Come nel karate, ogni livello ha il suo valore. Clicca per vedere il tuo premio personalizzato.</p>
      </div>

      <div className="mb-8">
        <p className="font-mono text-xs text-[#00FF41] uppercase tracking-wider mb-4 text-center">Ogni cintura, un premio diverso</p>
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-4">
          <button onClick={() => setPreviewBelt('Bianca')} data-testid="belt-white" className="bg-[#0A0A0A] border-2 border-white p-6 text-center hover:scale-105 transition-all group cursor-pointer">
            <div className="w-8 h-3 bg-white mx-auto mb-3 rounded-sm"></div>
            <p className="text-2xl font-black text-white mb-2">1€</p>
            <p className="text-white text-sm font-bold">Cintura Bianca</p>
            <p className="text-zinc-500 text-xs mt-1">Badge Digitale</p>
            <p className="text-[#00FF41] text-[10px] mt-2 font-mono opacity-0 group-hover:opacity-100 transition-opacity">CLICCA PER PREVIEW</p>
          </button>
          <button onClick={() => setPreviewBelt('Arancione')} data-testid="belt-orange" className="bg-[#0A0A0A] border-2 border-orange-500 p-6 text-center hover:scale-105 transition-all group cursor-pointer">
            <div className="w-8 h-3 bg-orange-500 mx-auto mb-3 rounded-sm"></div>
            <p className="text-2xl font-black text-orange-500 mb-2">5€</p>
            <p className="text-orange-500 text-sm font-bold">Cintura Arancione</p>
            <p className="text-zinc-500 text-xs mt-1">Penna Total Black</p>
            <p className="text-[#00FF41] text-[10px] mt-2 font-mono opacity-0 group-hover:opacity-100 transition-opacity">CLICCA PER PREVIEW</p>
          </button>
          <button onClick={() => setPreviewBelt('Verde')} data-testid="belt-green" className="bg-[#0A0A0A] border-2 border-green-500 p-6 text-center hover:scale-105 transition-all group cursor-pointer">
            <div className="w-8 h-3 bg-green-500 mx-auto mb-3 rounded-sm"></div>
            <p className="text-2xl font-black text-green-500 mb-2">10€</p>
            <p className="text-green-500 text-sm font-bold">Cintura Verde</p>
            <p className="text-zinc-500 text-xs mt-1">Supporto Bamboo</p>
            <p className="text-[#00FF41] text-[10px] mt-2 font-mono opacity-0 group-hover:opacity-100 transition-opacity">CLICCA PER PREVIEW</p>
          </button>
          <button onClick={() => setPreviewBelt('Blu')} data-testid="belt-blue" className="bg-[#0A0A0A] border-2 border-blue-500 p-6 text-center hover:scale-105 transition-all group cursor-pointer">
            <div className="w-8 h-3 bg-blue-500 mx-auto mb-3 rounded-sm"></div>
            <p className="text-2xl font-black text-blue-500 mb-2">15€</p>
            <p className="text-blue-500 text-sm font-bold">Cintura Blu</p>
            <p className="text-zinc-500 text-xs mt-1">T-shirt personalizzata</p>
            <p className="text-[#00FF41] text-[10px] mt-2 font-mono opacity-0 group-hover:opacity-100 transition-opacity">CLICCA PER PREVIEW</p>
          </button>
          <button onClick={() => setPreviewBelt('Marrone')} data-testid="belt-brown" className="bg-[#0A0A0A] border-2 border-amber-700 p-6 text-center hover:scale-105 transition-all group cursor-pointer">
            <div className="w-8 h-3 bg-amber-700 mx-auto mb-3 rounded-sm"></div>
            <p className="text-2xl font-black text-amber-700 mb-2">19€</p>
            <p className="text-amber-700 text-sm font-bold">Cintura Marrone</p>
            <p className="text-zinc-500 text-xs mt-1">T-shirt + Penna</p>
            <p className="text-[#00FF41] text-[10px] mt-2 font-mono opacity-0 group-hover:opacity-100 transition-opacity">CLICCA PER PREVIEW</p>
          </button>
        </div>
      </div>

      <div className="mb-12">
        <p className="font-mono text-xs text-[#00FF41] uppercase tracking-wider mb-4 text-center">Premi Esclusivi</p>
        <div className="grid md:grid-cols-2 gap-6">
          <button onClick={() => setPreviewBelt('Rossa')} data-testid="belt-red-premium" className="bg-gradient-to-br from-zinc-900 to-zinc-800 border-2 border-red-600 p-8 text-center hover:scale-105 transition-all relative overflow-hidden cursor-pointer group">
            <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-red-600/20 to-transparent rounded-bl-full"></div>
            <div className="w-10 h-3 bg-red-600 mx-auto mb-3 rounded-sm"></div>
            <p className="text-3xl font-black text-red-500 mb-2">50€</p>
            <p className="text-lg font-bold text-white mb-2">Cintura in Vera Pelle</p>
            <p className="text-zinc-400 text-sm">Con logo AI_covo.tech® — DIGITAL HUB SOCIALE — o il tuo brand impresso</p>
            <p className="text-[#00FF41] text-xs mt-4 font-mono">CINTURA ROSSA</p>
            <p className="text-[#00FF41] text-[10px] mt-2 font-mono opacity-0 group-hover:opacity-100 transition-opacity">CLICCA PER PREVIEW</p>
          </button>
          <button onClick={() => setPreviewBelt('Gran Maestro')} data-testid="belt-grandmaster-premium" className="bg-gradient-to-br from-amber-900/30 to-zinc-900 border-2 p-8 text-center hover:scale-105 transition-all relative overflow-hidden cursor-pointer group" style={{borderColor: '#FFD700'}}>
            <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-yellow-400/20 to-transparent rounded-bl-full"></div>
            <div className="w-10 h-3 mx-auto mb-3 rounded-sm" style={{background: 'linear-gradient(90deg, #FFD700 50%, #dc2626 50%)'}}></div>
            <p className="text-3xl font-black mb-2" style={{color: '#FFD700'}}>100€+</p>
            <p className="text-lg font-bold text-white mb-2">Cover Tablet + Smartphone + T-shirt + Penna</p>
            <p className="text-zinc-400 text-sm">Bundle completo per il vero Gran Maestro</p>
            <p className="text-[#00FF41] text-xs mt-4 font-mono">GRAN MAESTRO</p>
            <p className="text-[#00FF41] text-[10px] mt-2 font-mono opacity-0 group-hover:opacity-100 transition-opacity">CLICCA PER PREVIEW</p>
          </button>
        </div>
      </div>

      <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-8 mb-12 text-center">
        <h3 className="text-xl font-bold text-white mb-4">La tua T-shirt, la tua cintura</h3>
        <p className="text-zinc-400 mb-6">
          Il colore del tuo nome sulla T-shirt sarà il colore della tua cintura.<br />
          <span className="text-white">Più doni, più sali di grado.</span>
        </p>
        <div className="flex justify-center gap-4 flex-wrap">
          <span className="px-4 py-2 bg-black border border-white text-white text-sm">MARIO <span className="text-white">●</span></span>
          <span className="px-4 py-2 bg-black border border-orange-500 text-orange-500 text-sm">LUCIA <span className="text-orange-500">●</span></span>
          <span className="px-4 py-2 bg-black border border-green-500 text-green-500 text-sm">PAOLO <span className="text-green-500">●</span></span>
          <span className="px-4 py-2 bg-black border border-amber-700 text-amber-700 text-sm">ANNA <span className="text-amber-700">●</span></span>
        </div>
        <Link to="/tshirt" className="text-[#00FF41] text-sm hover:underline mt-4 inline-block">
          Vedi tutte le T-shirt →
        </Link>
      </div>

      <div className="bg-gradient-to-br from-emerald-900/20 to-[#0A0A0A] border border-emerald-500/30 p-8 text-center">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-400 mb-4">Per Aziende e Brand</p>
        <h3 className="text-2xl font-bold text-white mb-2">
          <span className="text-5xl font-black text-[#00FF41]">999€</span>
        </h3>
        <h3 className="text-xl font-bold text-white mb-4">
          Sponsor Aziendale — <span className="text-[#00FF41]">DEDUCIBILE 100%</span>
        </h3>
        <div className="grid md:grid-cols-3 gap-3 max-w-2xl mx-auto mb-6">
          <div className="bg-black/40 border border-emerald-500/20 p-3">
            <p className="text-emerald-400 font-bold text-sm">Logo su Sito + Social</p>
          </div>
          <div className="bg-black/40 border border-emerald-500/20 p-3">
            <p className="text-emerald-400 font-bold text-sm">Logo in Sede Hub</p>
          </div>
          <div className="bg-black/40 border border-[#00FF41]/30 p-3">
            <p className="text-[#00FF41] font-bold text-sm">PayPal 3 rate</p>
          </div>
        </div>
        <p className="text-zinc-400 mb-6 text-sm">
          Le erogazioni liberali alle associazioni culturali sono interamente deducibili dal reddito d'impresa.
        </p>
        <Link to="/dona" className="btn-primary bg-emerald-500 border-emerald-500 text-black hover:bg-emerald-400" data-testid="home-sponsor-cta">
          Diventa Sponsor
        </Link>
      </div>

      <div className="text-center mt-12">
        <p className="text-xl text-white font-bold">Tu, che cintura sei?</p>
      </div>
    </div>

    <PrizePreview isOpen={!!previewBelt} onClose={() => setPreviewBelt(null)} beltKey={previewBelt} />
  </section>
  );
};

export default SostieniciSection;
